import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider, ThemeProvider } from '@dreamtree-org/twreact-ui';
import '@dreamtree-org/twreact-ui/dist/index.css';
import './theme/tokens.css';
import './index.css';
import App from './App.jsx';
import { restoreBrand } from './theme/applyTheme';
import { loadDomainConfig } from './lib/domainResolver';

// Apply any saved per-tenant brand before first paint (runtime theming).
restoreBrand();

// Resolve api_base from GET /api/config/domains before the first request goes out.
// Never throws — on any failure the same-origin default stands, so a slow or missing
// endpoint delays boot at most one fetch, it doesn't block the app.
loadDomainConfig().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <StoreProvider>
        <ThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </StoreProvider>
    </React.StrictMode>
  );
});
